import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";

import { DataTableOption } from "../../lib/DataTableOption.type";
import {
  Appeal,
  AppealDTO,
  AppealFile,
  AppealFileDTO,
  AppealStatus,
  AppealType,
  EditAppealDto,
  EditAppealResult,
  FileData,
  NewAppeal,
  SaveAttachDTO,
} from "../../lib/appeal.type";
import { AppealService } from "@/services/api/appeal.service";
import router from "@/router";

@Module({
  dynamic: true,
  store,
  name: "module_appeals",
})
export class AppealsVuexModule extends VuexModule {
  tab: number = 0;
  appealStatusList: AppealStatus[] = [];
  appealTypeList: AppealType[] = [];
  appealList: Appeal[] = [];
  appealLoading: boolean = false;
  appealListPagination: DataTableOption = new DataTableOption();
  appealListLength: number = 0;
  newApp: NewAppeal = new NewAppeal();
  editReuslt: EditAppealResult = new EditAppealResult();
  fileList: AppealFile[] = [];
  fileListAES: AppealFile[] = [];
  fileData: FileData = new FileData();

  appealInList: Appeal[] = [];
  appealInLoading: boolean = false;
  appealInListPagination: DataTableOption = new DataTableOption();
  appealInListLength: number = 0;
  appealInStatusList: AppealStatus[] = [];
  appealInCount: number = 0;

  @Mutation
  clearFileList() {
    this.fileList = [];
  }

  @Mutation
  setTab(val: number) {
    this.tab = val;
  }

  @MutationAction
  public async getNewAppeal() {
    const newApp = await AppealService.getNewAppeal();
    return { newApp };
  }

  @MutationAction
  public async editAppeal(req: EditAppealDto) {
    const editReuslt = await AppealService.editAppeal(req);
    return { editReuslt };
  }

  @MutationAction
  public async loadSatatuses(TypeRid: number) {
    const appealStatusList = await AppealService.getStatuses(TypeRid);
    return { appealStatusList };
  }

  @MutationAction
  public async loadInSatatuses(TypeRid: number) {
    const appealInStatusList = await AppealService.getStatuses(TypeRid);
    return { appealInStatusList };
  }

  @MutationAction
  public async loadTypes() {
    const appealTypeList = await AppealService.getTypes();
    return { appealTypeList };
  }

  @MutationAction
  public async loadAppealList(req: AppealDTO) {
    const appealList = await AppealService.getAppealList(req);
    const newApp: NewAppeal = new NewAppeal();
    const editReuslt: EditAppealResult = new EditAppealResult();
    const appealLoading = false;
    const appealListLength =
      appealList.length > 0 ? appealList[0].row_count : 0;
    return { appealList, appealLoading, appealListLength, newApp, editReuslt };
  }

  @MutationAction
  public async loadAppealInList(req: AppealDTO) {
    const appealInList = await AppealService.getAppealList(req);
    const appealInLoading = false;
    const appealInListLength =
      appealInList.length > 0 ? appealInList[0].row_count : 0;
    return { appealInList, appealInLoading, appealInListLength };
  }

  @Mutation
  public setAppealInListPagination(val: DataTableOption) {
    this.appealInListPagination = val;
  }
  @Mutation
  public setAppealsInLoadig() {
    this.appealInLoading = true;
  }

  @Mutation
  public setAppealListPagination(val: DataTableOption) {
    this.appealListPagination = val;
  }

  @Mutation
  public setAppealsLoadig() {
    this.appealLoading = true;
  }

  @Action
  public newAppeal() {
    router.push({
      name: "new-appeal",
    });
  }

  @Action
  public openAppeal(id: number) {
    router.push({
      name: "edit-appeal",
      params: {
        RequestId: id.toString(),
      },
    });
  }

  @Action
  public openAppealIn(id: number) {
    router.push({
      name: "appeal-in",
      params: {
        RequestId: id.toString(),
      },
    });
  }

  @Action
  public async saveAttach(req: SaveAttachDTO) {
    const response = await AppealService.saveAttach(req);
    return response;
  }

  @Action
  public async deleteFile(req: AppealFileDTO) {
    const response = await AppealService.deleteFile(req);
    return response;
  }

  @MutationAction
  public async getFile(req: AppealFileDTO) {
    const fileData = await AppealService.getFile(req);
    return { fileData };
  }

  @MutationAction
  public async getFiles(req: SaveAttachDTO) {
    const fileList = await AppealService.getFiles(req);
    return { fileList };
  }

  @MutationAction
  public async getFilesAes(req: SaveAttachDTO) {
    const fileListAES = await AppealService.getFiles(req);
    return { fileListAES };
  }

  @Action
  public async sendToRoesAppeal(req: EditAppealDto) {
    const response = await AppealService.sendToRoesAppeal(req);
    return response;
  }

  @MutationAction
  public async getRequestsNotice() {
    const appealInCount = await AppealService.getRequestsNotice();
    return { appealInCount: appealInCount.result };
  }
}

export const AppealsModule = getModule(AppealsVuexModule);
